<template>
   <NuxtPage />
</template>

<script setup lang="ts">
definePageMeta({
   layout: 'legal',
})
</script>
